import { useAuthCompanyInfo } from "@vega-api/custom/api/hooks/useAuthCompanyInfo";
import { Logo, LogoTypes } from "@vega-core/components/Logo/Logo";
import { useTheme } from "@vega-core/context/ThemeContext/ThemeContext";
import { getLogo } from "@vega-core/helpers/getLogo.helper";

export const WelcomeHeader = () => {
  const { theme } = useTheme();

  const {
    logoDark: companyLogoDark,
    logoLight: companyLogoLight,
    name: companyName,
  } = useAuthCompanyInfo();

  return (
    <header className="h-14 px-13 py-2 flex items-center justify-center">
      <Logo
        alt={companyName}
        image={getLogo(
          theme === "default" ? "light" : theme,
          companyLogoLight,
          companyLogoLight,
          companyLogoDark,
        )}
        type={LogoTypes.XXL}
      />
    </header>
  );
};
